<template>
 <div class="product-header">

  <div class="product-header-content">
   <div style="width: 60%;">
    <div class="product-header-content-title">联系我们</div>
    <div class="product-header-content-jianjie">
     <p>
      我们期待与您携手，共同探索矿山智能化建设的创新之路。
     </p>
    </div>
    <div>
     <!-- <a-button class="learnmore-btn" type="primary" @click="$router.push('/contact')">联系我们</a-button> -->
    </div>
   </div>
   <div class="product-header-content-img">
    <img style="width: 100%;" src="../../assets/image/home/lxwm_card.png" alt="">
   </div>
  </div>


 </div>
 <div class="product-header-mobile">
  <div class="product-header-content-mobile">
   <div class="product-header-content-title-mobile">联系我们</div>
   <div class="product-header-content-mobile-img">
    <img style="width: 100%;" src="../../assets/image/home/lxwm_mobile_card.png" alt="">
   </div>
   <!-- <div class="product-header-content-jianjie-mobile ">
    我们期待与您携手，共同探索矿山智能化建设的创新之路。</div>
   <div>
   </div> -->

  </div>
 </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { getFilterList } from "@/api/index"
import learnmore from "@/components/learnmore.vue"

const dataInfo = ref(null)

const img_url = ref("")

const getImgUrl = (item) => {
 if (item['picture-upload8f5a8ab2'] && item['picture-upload8f5a8ab2'].length > 0) {
  return item['picture-upload8f5a8ab2'][0].url
 } else {
  return ""

 }
}
const getData = async () => {
 let params = {
  page: 1,
  pageSize: 1,
  worksheetId: "681ac245515de26d77262ca7",
 }
 const res = await getFilterList(params)
 if (res.code === 200 && res.data && res.data.length > 0) {
  dataInfo.value = res.data[0]
  img_url.value = `url(${getImgUrl(dataInfo.value)})`
 }

}

onMounted(() => {
 // getData()
})


</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .product-header {
  display: none !important;
 }

 .product-header-mobile {
  display: block;
 }
}

@media screen and (min-width: 800px) {
 .product-header {
  display: flex !important;
 }

 .product-header-mobile {
  display: none;
 }
}

.product-header-content-mobile {
 font-family: 'PuHuiTi';
 width: 100%;
 height: 225px;
 background: url("../../assets/image/home/banner_bg_mobile.png") no-repeat;
 background-size: 100% 100%;
 display: flex;
 justify-content: space-between;
 align-items: center;
}

.product-header-content-jianjie-mobile {
 width: 70%;
 font-size: 14px;
 margin-top: 10px;
 padding: 0 20px;
}

.product-header-content-mobile-img {
 width: 60%;
 height: 100%;
 max-width: 310px;
 display: flex;
 align-content: center;
 /* justify-content: space-evenly; */
 flex-direction: column-reverse;

}

.product-header-content-title-mobile {
 width: 40%;
 word-break: keep-all;
 white-space: nowrap;
 font-size: 26px;
 font-weight: 500;
 margin-top: 60px;
 padding: 0 20px;
}

.product-header {
 font-family: 'PuHuiTi';
 width: 100%;
 height: 450px;
 background: url("../../assets/image/home/banner_bg.png") no-repeat;
 background-size: 100% 100%;
 display: flex;
 justify-content: center;
}

.product-header-content {
 width: 100%;
 height: 100%;
 margin-left: 18%;
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding-top: 120px;
}

.product-header-content-img {
 width: 80rem;
 margin-right: 18%;
}

.product-header-content-title {
 font-size: 36px;
 font-weight: 500;
}

.product-header-content-jianjie {
 width: 50%;
 font-size: 16px;
 margin-top: 20px;
 margin-bottom: 60px;
}

.learnmore-btn {

 width: 210px;
 height: 46px;
 border-radius: 10px;
}
</style>